import { UPDATE_FLOW_START_SUCCESS, UPDATE_FLOW_START_FAILURE } from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

export const flowStart = (state = {}, action) => {
  switch (action.type) {
    // -- UPDATE A FLOW START
    case UPDATE_FLOW_START_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] flowStart.UPDATE_FLOW_START_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_FLOW_START_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] flowStart.UPDATE_FLOW_START_SUCCESS()', { state, action })

      return {
        ...state,
        ...action.data
      }
    }

    default:
      return state
  }
}
